import { exportMarumiyaProducts, getMarumiyaProducts } from '@/apis/marumiyaProductAPI'

import { IMarumiyaProduct } from '@/utils/types/model/marumiyaProduct'
import {
  CLEAR_MARUMIYA_PRODUCTS,
  EXPORT_MARUMIYA_PRODUCTS,
  FETCH_MARUMIYA_PRODUCTS,
  SET_MARUMIYA_PRODUCT_LOADING,
} from './actions'

type TMarumiyaProductState = {
  marumiyaProducts: IMarumiyaProduct[]
  totalRecords: number
  isLoaded: boolean
  isLoading: boolean
}

export default {
  state: {
    marumiyaProducts: [],
    totalRecords: 0,
    isLoaded: false,
    isLoading: false,
  },
  mutations: {
    [FETCH_MARUMIYA_PRODUCTS]: (
      state: TMarumiyaProductState,
      payload: {
        marumiyaProducts: IMarumiyaProduct[]
        totalRecords: number
      }
    ) => {
      state.marumiyaProducts = payload.marumiyaProducts
      state.totalRecords = payload.totalRecords
      state.isLoaded = true
      state.isLoading = false
    },
    [CLEAR_MARUMIYA_PRODUCTS]: (state: TMarumiyaProductState) => {
      state.marumiyaProducts = []
      state.totalRecords = 0
      state.isLoaded = false
      state.isLoading = false
    },
    [SET_MARUMIYA_PRODUCT_LOADING]: (state: TMarumiyaProductState, loading: boolean) => {
      state.isLoading = loading
    },
  },
  actions: {
    [FETCH_MARUMIYA_PRODUCTS]: async (
      { commit }: { commit: Function },
      payload: {
        page?: number
        limit?: number
        itemCode?: string
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_MARUMIYA_PRODUCT_LOADING, true)
        const params = {
          page: payload.page ?? 1,
          limit: payload.limit ?? 10,
          ...(payload.itemCode !== undefined ? { itemCode: payload.itemCode } : {}),
          ...(payload.sortBy !== undefined ? { sortBy: payload.sortBy } : {}),
          ...(payload.sortType !== undefined ? { sortType: payload.sortType } : {}),
        }
        const response = await getMarumiyaProducts(params)
        if (!response) {
          throw new Error('No response from API')
        }
        commit(FETCH_MARUMIYA_PRODUCTS, {
          marumiyaProducts: response.products || [],
          totalRecords: response.totalRecords || 0,
        })
        return response
      } catch (err) {
        commit(SET_MARUMIYA_PRODUCT_LOADING, false)
        throw err
      }
    },
    [EXPORT_MARUMIYA_PRODUCTS]: async (
      { commit }: { commit: Function },
      payload: {
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_MARUMIYA_PRODUCT_LOADING, true)
        const data = {
          ...(payload.sortBy && { sortBy: payload.sortBy }),
          ...(payload.sortType && { sortType: payload.sortType }),
        }
        const response = await exportMarumiyaProducts(data)
        commit(SET_MARUMIYA_PRODUCT_LOADING, false)
        return response
      } catch (err) {
        commit(SET_MARUMIYA_PRODUCT_LOADING, false)
        throw err
      }
    },
    [CLEAR_MARUMIYA_PRODUCTS]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_MARUMIYA_PRODUCTS)
    },
  },
  getters: {
    getMarumiyaProducts: (state: TMarumiyaProductState) => state.marumiyaProducts,
    getMarumiyaProductTotalRecords: (state: TMarumiyaProductState) => state.totalRecords,
    isMarumiyaProductLoading: (state: TMarumiyaProductState) => state.isLoading,
    isMarumiyaProductLoaded: (state: TMarumiyaProductState) => state.isLoaded,
  },
}
